/* global axios */
import ApiClient from './ApiClient';

class EmailTriageAPI extends ApiClient {
  constructor() {
    super('email_triage_entries', { accountScoped: true });
  }

  promote(entryId) {
    return axios.post(`${this.url}/${entryId}/promote`);
  }

  markNotSupport(conversationId) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/email_triage`
    );
  }
}

export default new EmailTriageAPI();
